import React from "react";

const UserTickIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={` ${className || "h-3 w-3 text-primary-500 mr-2"}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="8.5" cy="7" r="4" />
      <polyline points="17 11 19 13 23 9" />
    </svg>
  );
};

export default UserTickIcon;
